import React, { useState, useContext, useMemo, useEffect } from "react";
import ActionPlansContext from "context/ActionPlansContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UploadScenario from "./UploadScenario";
import FilterData from "./FilterData";
import "assets/css/customNotifications.css";

export default function useScenarioTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");

  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState();
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext = useContext(ActionPlansContext);
  const { actionPlans } = appContext;

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {
    setResults(actionPlans);
  }, [isRefetched, actionPlans]);

  const [filterText, setFilterText] = useState("");
  const [filterId, setFilterId] = useState("Text");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const FilterButton = styled.div`
    margin-right: 15px;
    &:hover {
      cursor: pointer;
    }
  `;

  const UploadButton = styled.div`
    margin-left: 15px;
    &:hover {
      cursor: pointer;
    }
  `;

  const TableName = styled.h1`
    margin-right: auto;
    margin-left: -8px;
    font-size: 1.3rem;
    font-weight: 500;
  `;

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const FilterComponent = ({ onUpload }) => (
    <>
      <FilterButton type="button" onClick={onUpload}>
        {/*<PublishIcon fontSize="default" />
        <UploadText>Import</UploadText>*/}
        <FilterData />
      </FilterButton>
    </>
  );

  const UploadComponent = ({ onUpload }) => (
    <UploadButton type="button" onClick={onUpload}>
      <UploadScenario
        onClick={onUpload}
        refetch={refreshTable}
        //setLoading={setLoading}
      />
    </UploadButton>
  );

  const filteredItems = _.get(results, "scenarios", []).filter(
    (item) =>
      (item.parameters.name &&
        item.parameters.name
          .toLowerCase()
          .includes(filterText.toLowerCase())) ||
      (item.parameters.code &&
        item.parameters.code.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    return (
      <>
        <TableName>Gestion des scenarios</TableName>
        {/* <FilterComponent key="UploadComponent" onUpload={handleClear} /> */}
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {actionplanadmin && (
          <UploadComponent key="UploadComponent" onUpload={handleClear} />
        )}
      </>
    );
  }, [filterText, resetPaginationToggle]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
    },
    refreshTable,
    setLoading,
  };
}
